import SiteLayout from "@/components/feature/SiteLayout";
import { allNews, latestWorks, popularWorks } from "@/mocks";
import HeroCarousel from "./components/HeroCarousel";
import HomeSections from "./components/HomeSections";

export default function Home() {
  const latest = latestWorks(9);
  const popular = popularWorks(5);
  const slides = popularWorks(4);

  return (
    <SiteLayout>
      <h1 className="sr-only">女友的妈妈影视专区 - 电影电视剧剧情及资讯</h1>
      <HeroCarousel slides={slides} />
      <HomeSections latest={latest} popular={popular} news={allNews} />
    </SiteLayout>
  );
}